<div class="flex flex-col gap-4 p-2">
	@if (condition) {
		<div class="border-b border-gray-100 pb-3">
			<h4 class="text-base font-semibold text-gray-900">{{ condition.label }}</h4>
			@if (condition.text && condition.text !== condition.label) {
				<p class="text-sm text-gray-500 mt-1">{{ condition.text }}</p>
			}
		</div>

		@if (loading) {
			<div class="flex justify-center py-8">
				<span class="loading loading-spinner loading-lg text-primary"></span>
			</div>
		} @else if (error) {
			<div class="p-4 bg-error/10 text-error rounded-lg text-sm">
				{{ error }}
			</div>
		} @else if (history.length === 0) {
			<div class="p-4 bg-gray-50 rounded-lg text-sm text-gray-500 text-center">
				Aucun historique disponible
			</div>
		} @else {
			<div class="space-y-3 max-h-[50vh] overflow-y-auto">
				<h5 class="text-xs font-medium text-gray-500 uppercase tracking-wide">Historique des versions</h5>
				<div class="relative">
					<div class="absolute left-3 top-0 bottom-0 w-px bg-gray-200"></div>
					@for (item of history; track item._id; let last = $last) {
						<div class="relative flex gap-4 pl-8 pb-4" [class.pb-0]="last">
							<div class="absolute left-0 w-3 h-3 rounded-full mt-1.5 shrink-0"
								[class.bg-primary]="item.isCurrent"
								[class.bg-gray-300]="!item.isCurrent"></div>
							<div class="flex-1 min-w-0 py-3 px-4 rounded-lg border transition-colors"
								[ngClass]="item.isCurrent ? 'bg-primary/5 border-primary/20' : 'bg-gray-50 border-gray-100'">
								<div class="flex flex-wrap items-center justify-between gap-2 mb-2">
									<div class="flex items-center gap-2">
										@if (item.version) {
											<span class="text-xs font-semibold text-gray-600">Version {{ item.version }}</span>
										}
										@if (item) {
											<span class="text-[11px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 font-medium">Auteur: {{ getAuthor(item) }}</span>
										}
										<span class="badge badge-sm" [class.badge-success]="item.clinicalStatus === 'active'" [class.badge-ghost]="item.clinicalStatus !== 'active'">
											{{ getStatusLabel(item.clinicalStatus) }}
										</span>
										@if (item.isCurrent) {
											<span class="badge badge-sm badge-primary badge-outline">Actuel</span>
										}
									</div>
									<span class="inline-flex items-center gap-1 text-xs text-gray-500">
										<lucide-icon [img]="Calendar" [size]="12"></lucide-icon>
										{{ formatDate(item.updatedAt || item.createdAt) }}
									</span>
								</div>
								@if (item.text && item.text.trim()) {
									<p class="text-sm text-gray-600 mt-1">{{ item.text }}</p>
								}
								@if (item.createdAt && item.updatedAt && item.createdAt !== item.updatedAt) {
									<p class="text-xs text-gray-400 mt-2">
										Créé le {{ formatDate(item.createdAt) }}
									</p>
								}
							</div>
						</div>
					}
				</div>
			</div>
		}

		<div class="flex justify-end pt-2 border-t border-gray-100">
			<button type="button" class="btn btn-sm btn-ghost" (click)="closeModal()">
				Fermer
			</button>
		</div>
	} @else {
		<div class="p-4 bg-error/10 text-error rounded-lg text-sm mb-2">{{ error }}</div>
		<div class="flex justify-end pt-2 border-t border-gray-100">
			<button type="button" class="btn btn-sm btn-ghost" (click)="closeModal()">
				Fermer
			</button>
		</div>
	}
</div>
